<template>
	<div class="po-r" style="padding: 1.43rem 0;">
		<div class="bg-text">PRODUCTS</div>
		<div class="big-title">{{title}}</div>
		<switch-bar ref="switchBar" class="ptb-30" :list="head_list" v-model="head_index" rangeKey="title"></switch-bar>

		<!-- 手机端样式 -->
		<div class="content" style="margin-top: 10px;"  v-if="is_phone">
			<OImage :src="head_list[head_index].img" height="400"></OImage>
			<div class="fs-18 fw mt-40">{{ head_list[head_index].title }}</div>
			<div class="fs-14 products-desc-phone">{{ head_list[head_index].info }}</div>
			<read-more :url="head_list[head_index].url"></read-more>
		</div>

		<!-- PC端 -->
		<div class="flex-c products" v-else>
			<div class="flex1 pr-25">
				<div class="fs-18 fw">{{ head_list[head_index].title }}</div>
				<div class="fs-14 lh-24 products-desc">{{ head_list[head_index].info }}</div>
				<read-more :url="head_list[head_index].url"></read-more>
			</div>
			<OImage v-for="(v, i) in head_list" :key="i" :src="$imgUrl + v.img" v-show="head_index == i" wh="1008,488"></OImage>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			head_list: [{}],
			head_index: 0,
			title:'',
		};
	},
	created() {
		this.$get({
			url: 'app/getProducts',
			success: res => {
				this.head_list = res.list;
				this.title = res.menuName;
			}
		});
	},
	methods: {}
};
</script>

<style scoped="scoped">
.products-img {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	width: 10.08rem;
	height: 4.88rem;
}
/* 产品中心 */
.products {
	margin-left: 3.21rem;
	margin-right: 1.61rem;
}
.bg-text {
	color: #f9fafa;
	font-size: 390px;
	line-height: 3.6rem;
	font-weight: bold;
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
}
.products-desc {
	margin: 0.3rem 0;
	color: #666666;
}
.products-desc-phone {
	margin: 0.3rem 0;
	color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/products.vue